
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/advancedStylePanel/templates/coverImage/coverImage.scss.css.virtualfile';
        module.exports = {"mediaAddPosterIndicator":"_mediaAddPosterIndicator_1qu04_7","st1":"_st1_1qu04_14","st2":"_st2_1qu04_16","st3":"_st3_1qu04_18"};